import { esriGeometryEngine, Point, Polygon, Polyline } from 'cd-eft/utils/esriTypes';
import { observable } from 'mobx';
import { GroundPoint } from './GroundPoint';
import { AppConstants } from 'cd-eft/appConstants';



/**
 * GroundPointEditAdapter implements a class adapter design pattern. The adapted ground points
 * comprise the surveyEditables which track current state of points being edited by both
 * the pending edits manager and the survey data grid.
 */
class GroundPointEditAdapter extends GroundPoint {
  constructor(groundPoint: GroundPoint) {
    super();
    this.id = groundPoint.id;
    this.description = groundPoint.description;
    this.editing_status = groundPoint.editing_status;
    this.name = groundPoint.name;
    this.x = groundPoint.x;
    this.y = groundPoint.y;
    this.z = groundPoint.z;
    this.visible = groundPoint.visible;
    this.tinable = groundPoint.tinable;
    this.wkid = groundPoint.wkid;
  }

  //override parent's properties with attached decorators
  @observable visible: number = 0;
  @observable tinable: number = 0;
  @observable name: string = '';
  @observable description: string = '';
  // @observable editing_status: string = 'original';

  public get pointName(): string {
    return this.name;
  }

  public set pointName(value: string) {
    this.name = value;
  }

  public get featureDescription(): string {
    return this.description;
  }

  public set featureDescription(value: string) {
    this.description = value;
  }

  applyBorder(borderPolygon: Polygon, borderPolyline: Polyline) {
    const pnt: Point = this.generateGeometry(borderPolygon.spatialReference);
    const isInsider = esriGeometryEngine.contains(borderPolygon, pnt);
    const isOnBorder = esriGeometryEngine.intersects(borderPolyline, pnt);

    // 0. this.tinable = isInsider ? 1 : 0;

    // 1. if (this.tinable === 1 && !isInsider) {
    //   this.tinable = 0;
    // }
    // if (isOnBorder) this.tinable = 1;

    const previousTinable = this.tinable;

    if (this.editing_status === AppConstants.SURFACE_USER_EDIT) {
      if (isOnBorder) this.tinable = 1;
      if (!isOnBorder && !isInsider) this.tinable = 0;
    } else {
      this.tinable = isInsider || isOnBorder ? 1 : 0;
    }
    if (this.tinable !== previousTinable) this.editing_status = AppConstants.SURFACE_PROGRAMMATIC;

    // sync tinable with visible
    if (this.tinable === 1) this.visible = 1;
  }
}

export { GroundPointEditAdapter };
